const PATH = 'fe.pages.testing.reliability.score_report.dimension_section';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'Test Results by Dimension'
  },
  videos: {
    key: `${PATH}.videos`,
    defaultValue: 'Videos'
  },
  video: {
    key: `${PATH}.video`,
    defaultValue: 'Video'
  },
  columnTitle: {
    key: `${PATH}.column_title`,
    defaultValue: 'Domain/Dimension'
  },
  overall: {
    key: `${PATH}.overall`,
    defaultValue: 'Overall'
  },
  reliable: {
    key: `${PATH}.reliable`,
    defaultValue: 'Reliable'
  },
  notReliable: {
    key: `${PATH}.not_reliable`,
    defaultValue: 'Not reliable'
  },
  twoOfFiveRulePassed: {
    key: `${PATH}.two_of_five_rule_passed`,
    defaultValue: 'Meets the 2 of 5 rule'
  },
  twoOfFiveRuleFailed: {
    key: `${PATH}.two_of_five_rule_failed`,
    defaultValue: "Doesn't meet the 2 of 5 rule"
  },
  note: {
    key: `${PATH}.note`,
    defaultValue:
      'Note: This report has been updated to provide detailed performance data at the dimensions per video level, as a result we no longer share coding trends that were often unclear.'
  },
  passed: {
    key: `${PATH}.passed`,
    defaultValue: 'Passed'
  },
  failed: {
    key: `${PATH}.failed`,
    defaultValue: 'Failed'
  }
};

export default messages;
